import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { finalize, map } from "rxjs/operators";
import { Billing, billingResponse } from "src/app/models/license.model";
import { GeneralService } from "src/app/services/general.service";
import Swal from "sweetalert2";
import { SignupModel } from "../../models/signUp.model";
import { Endpoints } from "../../shared/config/endpoints";

@Injectable({
  providedIn: "root",
})
export class StandaloneSignupService {
  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(
    private endPoints: Endpoints,
    private http: HttpClient,
    private gs: GeneralService
  ) { }

  testLoading() {
    this.loadingSubject.next(true);
    setTimeout(() => {
      this.loadingSubject.next(false);
    }, 30000);
  }

  public get loadingSubjectValue(): any {
    return this.loadingSubject.value;
  }

  /**
   * signup a new user
   * @param payload Signup user information to be passed to the server
   */
  registerUser(payload: SignupModel) {
    this.loadingSubject.next(true);
    const body = {
      ...payload,
      city: "",
      country: "",
      dateOfBirth: "",
      emailConfirm: false,
      mobileNo: "",
      phoneNo: "",
      state: "",
      street: "",
      token: "",
      website: "",
    };

    return this.http
      .post(
        `${this.endPoints.signupUrl + this.endPoints.signUpApis.createUser}`,
        body
      )
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
        })
      );
  }

  /**
   * login user
   * @param payload Login user information to be passed to the server
   */
  loginUser(payload: SignupModel) {
    this.loadingSubject.next(true);

    return this.http.post(`${this.endPoints.signupUrl}/doLogin`, payload).pipe(
      finalize(() => {
        this.loadingSubject.next(false);
      })
    );
  }

  validateUser(userID) {
    this.loadingSubject.next(true);

    return this.http
      .get(`${this.endPoints.signupUrl}/validateUser/${userID}`)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
        })
      );
  }

  /**
   * create new organization
   * @param payload
   */
  createOrganization(payload: any) {
    this.loadingSubject.next(true);

    const body = {
      ...payload,
      city: "",
      countryCode: "",
      currencyType: "",
      dateOfEstablishment: "",
      mobile: "",
      plan: "",
      planStatus: "",
      state: "",
      street: "",
      taxName: "",
      taxPercentage: "",
      website: "",
      displayUriPath: "",
      downloadUriPath: "",
      notchStatus: 0,
      requireCreditProfile: true,
      termsAndConditions: "",
    };
    return this.http
      .post(`${this.endPoints.signupUrl}/newOrganization`, body)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
        })
      );
  }

  /**
   * update organization
   * @param payload
   */
  updateOrganization(payload: any) {
    this.loadingSubject.next(true);

    return this.http
      .post(`${this.endPoints.signupUrl}/editOrganization`, payload)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
        })
      );
  }

  getOrganization(id: any) {
    this.loadingSubject.next(true);

    return this.http
      .get(`${this.endPoints.signupUrl}/Organization/${id}`)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
        })
      );
  }

  /**
   * Get licenses
   */
  getLicenses() {
    // this.gs.showSpinner.next(true);

    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.endPoints.adminserviceUrl}/getLicenses`,{headers})
      .pipe(map((licenses: any[]) => {
        return licenses.sort((a, b) => a.id - b.id);
      }))
      .pipe(finalize(() => {
        this.gs.showSpinner.next(false);
      })
      );
  }

  /**
   * create new license billing
   * @param payload
   */
  createBilling(payload: Billing) {
    this.loadingSubject.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.post(`${this.endPoints.adminserviceUrl}/newBilling`, payload,{headers})
      .pipe(finalize(() => {
        this.loadingSubject.next(false);
      })
      );
  }
  newBilling(payload) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.post(`${this.endPoints.adminserviceUrl}/newBilling`, payload, {headers})
  }

  /**
   * Edit license billing
   * @param payload : Billing
   */
  eidtBilling(payload: Billing) {
    this.loadingSubject.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    this.http
      .post(`${this.endPoints.adminserviceUrl}/editBilling`, payload,{headers})
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
        })
      )
      .subscribe((resp: any) => {
        if (resp.status === "SUCCESS") {
          Swal.fire({
            type: "success",
            title: "Updated Billing Successfully",
          });
        } else {
          Swal.fire({
            type: "error",
            title: "Failed To Update Billing",
          });
        }
      });
  }

  /**
   * Get tenant Active billing license/subscription
   */
  getTenantActiveBilling(tenantID) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .get(
        `${this.endPoints.adminserviceUrl}/${tenantID}/getLicenseFromBilling`,{headers}
      )
      .pipe(finalize(() => { }));
  }
  /**
   * get user subscription info {active sub, billing history and cards}
   */
  getUserSubscriptionContext(userID, orgID) {
    // debugger;
    this.gs.showSpinner.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .get(
        `${this.endPoints.adminserviceUrl}/${userID}/${orgID}/getSubscription`,{headers}
      )
      .pipe(
        finalize(() => {
          this.gs.showSpinner.next(false);
        })
      );
  }

  /**
   * get user subscription info {active sub, billing history and cards}
   */
  getUserSubscriptionContext2(userID, orgID) {
    // debugger;
    this.gs.showSpinner.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .get(
        `${this.endPoints.adminserviceUrl}/${userID}/${orgID}/getSubscription2`,{headers}
      )
      .pipe(
        finalize(() => {
          this.gs.showSpinner.next(false);
        })
      );
  }
  /**
   * create new license billing
   * @param payload
   */
  createCard(payload: billingResponse) {
    // this.loadingSubject.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .post(`${this.endPoints.adminserviceUrl}/newBillingPayment`, payload,{headers})
      .pipe(
        finalize(() => {
          // this.loadingSubject.next(false);
        })
      );
  }
  /**
   * get user billing cards
   */
  getUserBillingCard(userID) {
    this.gs.showSpinner.next(true);
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
      .get(
        `${this.endPoints.adminserviceUrl}/${userID}/getAllUserBillingPayment`,{headers}
      )
      .pipe(
        finalize(() => {
          this.gs.showSpinner.next(false);
        })
      );
  }
  getCountry() {
    // const ipAddress = "105.112.131.33";

    // return this.http.get(`http://api.ipstack.com/${ipAddress}?access_key=f7c81430bc757a2a0cc70f2e22c1af56&format=1`);
    return this.http.get<any>("https://api.db-ip.com/v2/free/self").pipe(map(data => {
      const newData = {
        ...data,
        countryCode: data.countryCode,
        country: data.countryName
      }
      return newData;
    }));
  }


  /**
   * *Get License By ID
   */
   getLicenseById(id){
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.endPoints.adminserviceUrl}/${id}/getLicense`,{headers})
    .pipe(map((licenses: any[]) => {
      return licenses;
    }))
    .pipe(finalize(() => {
      this.gs.showSpinner.next(false);
    })
    );
  }

  /**
   * Get Addon Licenses
   */
   getAssociatedAddonLicencesById(id:number){
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.endPoints.adminserviceUrl}/getLicenseAddons/${id}`,{headers})
    .pipe(map((licenses: any[]) => {
      return licenses;
    }))
    .pipe(finalize(() => {
      this.gs.showSpinner.next(false);
    })
    );

  }

   
    getAllOrganizationLicenseContext(orgID) {
    const headers = this.gs.getCommandCenterHeaders();
      return this.http
        .get(
          `${this.endPoints.adminserviceUrl}/${orgID}/getAllRunningBilling`,{headers}
        )
    }

    addUserToLicense(payload) {
    const headers = this.gs.getCommandCenterHeaders();
      return this.http
        .post(`${this.endPoints.adminserviceUrl}/addUserToLicense`, payload, {headers})
    }

    removeUsersFromLicense(payload) {
    const headers = this.gs.getCommandCenterHeaders();
      return this.http
        .post(`${this.endPoints.adminserviceUrl}/removeUsersFromLicense`, payload,{headers})
    }

    /**
   * Get all trial, addon and regular licenses
   */
  getAllLicenses() {
    // this.gs.showSpinner.next(true);

    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.endPoints.adminserviceUrl}/getAllLicenses`,{headers})
      .pipe(map((licenses: any[]) => {
        return licenses.sort((a, b) => a.id - b.id);
      }))
      .pipe(finalize(() => {
        this.gs.showSpinner.next(false);
      })
      );
  }

  autoRenewBillings(payload) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
        .post(`${this.endPoints.adminserviceUrl}/autoRenewBillings`, payload,{headers})
  }

  deleteCard(cardId) {
    const headers = this.gs.getCommandCenterHeaders();
    return this.http
        .post(`${this.endPoints.adminserviceUrl}/${cardId}/deleteBillingPayment`, {},{headers});
  }
  
   getAssociatedAddonsLicencesById(id:number){
    const headers = this.gs.getCommandCenterHeaders();
    return this.http.get(`${this.endPoints.adminserviceUrl}/getLicenseAddons/${id}`,{headers});
  }

}
